import { Component, OnDestroy, OnInit } from '@angular/core';
import { HelperProvider } from '../providers/helper.provider';
import { Page } from '../model/page';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { Pair } from 'src/model/pair';
import { RestService } from 'src/providers/rest.service';
import { FaturalarPage } from 'src/model/faturalar-page';
import { TaleplerPage } from 'src/model/talepler-page';
import { Talep } from 'src/model/talep';
import { AuthService } from 'src/auth/auth.service';
import { Sube } from 'src/model/sube';

@Component({
  selector: 'app-faturalar',
  templateUrl: './faturalar.component.html',
  styleUrls: ['./faturalar.component.css']
})
export class FaturalarComponent implements OnInit, OnDestroy {
  faturaAraLoading = false;
  faturaAraText = '';
  faturaAraText1 = '';
  faturaAraText2 = '';
  muhSubeKoduFilter = 0;
  searchResults: FaturalarPage = null;
  showSearchResultText = '';
  showSearchResultCount = 10;
  showSearchResultCount1 = 10;
  showSearchResultCount2 = 10;
  showSearchResultCountTalep = 10;
  showSearchResultCountModel: number[] = [10, 20, 50, 100];
  showSearchResultCountModel2: number[] = [10, 20, 50, 100];
  showSearchResultCountModelTalep: number[] = [10, 20, 50, 100];
  source: FaturalarPage = null;
  source2: FaturalarPage = null;
  showSearchCurrentPage = 1;
  showSearchCurrentPage1 = 1;
  showSearchCurrentPage2 = 1;
  showSearchCurrentPageTalep = 1;
  filterStatus: Pair[] = [];
  private subscriptions: Subscription[] = [];
  private isAktarildi = false;

  sourceTalep: TaleplerPage = null;
  talepAraText = '';
  talepAraLoading = false;

  isOnayimdakiler: boolean = false;

  /**
   * Arayüzden seçilen şubenin idsini tutmak için kullanılır.
   */
  selectedSubeId: number = null;

  /**
   * Şube verilerini tutmak için kullanılır.
   */
   subeler: Sube[] = null;

  constructor(private helperProvider: HelperProvider,
    private router: Router,
    private restService: RestService,
    private authService: AuthService) {
  }

  ngOnInit(): void {
    this.helperProvider.currentPage$.next(Page.Faturalar);
    this.isOnayimdakiler = this.authService.getIsConfirm();

    this.subscriptions.push(this.helperProvider.isConfirmation$.subscribe(res => {
      if (res != null) {
        this.isOnayimdakiler = this.authService.getIsConfirm();
        this.getFaturalar();
      }
    }));

    this.getFaturalar();
    this.getTalepler();
    this.getSubeler();
    this.subscriptions.push(this.helperProvider.changedSelectedBranches$.subscribe(res => {
      if (res != null) {
        this.getFaturalar();
        this.getTalepler();
      }
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  getFaturalar() {
    const durum = this.filterStatus.filter(x => x.value).map(x => x.key);
    this.restService.faturalar(this.showSearchCurrentPage1, this.showSearchResultCount1, durum, false, this.faturaAraText1, this.isOnayimdakiler).subscribe(res => {
      this.source = res;
    });

    this.restService.faturalar(this.showSearchCurrentPage2, this.showSearchResultCount2, durum, true, this.faturaAraText2).subscribe(res => {
      this.source2 = res;
    });
  }

  getTalepler() {
    const durum = this.filterStatus.filter(x => x.value).map(x => x.key);
    this.restService.talepler(this.showSearchCurrentPageTalep, this.showSearchResultCountTalep, durum, this.talepAraText, false, 2).subscribe(res => {
      this.sourceTalep = res;
      this.sourceTalep.isFatura = true;
    });
  }

  new() {
    this.router.navigate(['fatura'], { queryParams: { id: '0' } });
  }

  faturaAraInputChange(tip: number) {
    if (tip === 1) {
      this.showSearchCurrentPage1 = 1;
    } else if (tip === 2) {
      this.showSearchCurrentPage2 = 1;
    }

    this.faturaAra(tip);
  }

  showPreviousPageSearchResults(tip: number) {
    if (tip === 1) {
      this.showSearchCurrentPage1--;
    } else if (tip === 2) {
      this.showSearchCurrentPage2--;
    }

    this.faturaAra(tip);
  }

  showNextPageSearchResults(tip: number) {
    if (tip === 1) {
      this.showSearchCurrentPage1++;
    } else if (tip === 2) {
      this.showSearchCurrentPage2++;
    }

    this.faturaAra(tip);
  }
  faturaAra(tip: number) {
    const durum = this.filterStatus.filter(x => x.value).map(x => x.key);

    if (tip === 1) {
      this.showSearchResultCount = this.showSearchResultCount1;
      this.showSearchCurrentPage = this.showSearchCurrentPage1;
      this.faturaAraText = this.faturaAraText1;
      this.isAktarildi = false;
    }
    else if (tip === 2) {
      this.showSearchResultCount = this.showSearchResultCount2;
      this.showSearchCurrentPage = this.showSearchCurrentPage2;
      this.faturaAraText = this.faturaAraText2;
      this.isAktarildi = true;
    }

    if (this.showSearchResultCount < 1) {
      this.showSearchResultCount = 10;
    }

    if (this.showSearchResultCount > 100) {
      this.showSearchResultCount = 100;
    }

    this.faturaAraLoading = true;
    setTimeout(() => {
      this.faturaAraLoading = false;
    }, 10000);

    this.restService.faturalar(this.showSearchCurrentPage, this.showSearchResultCount, durum, this.isAktarildi, this.faturaAraText).subscribe(res => {
      if (res) {

        if (tip === 1) {
          this.source = null;
          this.source = res;
        }
        else if (tip === 2) {
          this.source2 = null;
          this.source2 = res;
        }
        //this.showSearchResultText = this.faturaAraText;
      }
      this.faturaAraLoading = false;
    });

  }

  showPreviousPageSearchResultsTalep() {
    this.showSearchCurrentPageTalep--;
    this.getTalepler();
  }

  showNextPageSearchResultsTalep() {
    this.showSearchCurrentPageTalep++;
    this.getTalepler();
  }

  talepAraInputChange() {
    this.showSearchCurrentPageTalep = 1;
    this.getTalepler();
  }


  getSubeler() {
    this.restService.subeler().subscribe(res => {
      if (res != null) {
        this.subeler = res;
      }
    }, error => {
      this.helperProvider.showConnectionError$.next(true);
    });
  }


  /**
   * Şube seçiminde çalışır
   * @param id seçilen şubenin id'sini verir. 
   */
   onChangeSube(id: number): void {
    this.selectedSubeId = id;
    if (this.selectedSubeId > 0) {
      this.restService.getSubeTalep(this.selectedSubeId).subscribe(res => {
        if (res != null) {
          // this.dashboard = res;
        }
      }, error => {
        this.helperProvider.showConnectionError$.next(true);
      });
    } else {
      // this.dashboard = null;
    }
  }
}
